import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule } from 'shared/modules/controls/controls.module';
import { MaterialModule } from 'shared/modules/material/material.module';
import { SkeletonModule } from 'shared/modules/skeleton/skeleton.module';
import { ColumnSelectComponent } from 'shared/modules/table/column-select/column-select.component';
import { SelectionComponent } from 'shared/modules/table/selection/selection.component';
import { SimpleSortHeaderComponent } from 'shared/modules/table/simple-sort-header/simple-sort-header.component';
import { SortingPopoverComponent } from 'shared/modules/table/sorting-popover/sorting-popover.component';
import {
  DisableTableDirective,
  PopoverSortDirective,
  TableColumnDirective,
  TableHeaderDirective,
  TableRowDirective,
} from 'shared/modules/table/table-utils/table-directives';
import { TableComponent } from 'shared/modules/table/table/table.component';

@NgModule({
  declarations: [
    TableColumnDirective,
    TableComponent,
    TableHeaderDirective,
    TableRowDirective,
    DisableTableDirective,
    SelectionComponent,
    PopoverSortDirective,
    SortingPopoverComponent,
    SimpleSortHeaderComponent,
    ColumnSelectComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SkeletonModule,
    ReactiveFormsModule,
    TranslateModule,
    ControlsModule,
  ],
  exports: [
    TableColumnDirective,
    TableComponent,
    TableHeaderDirective,
    TableRowDirective,
    DisableTableDirective,
    SelectionComponent,
    PopoverSortDirective,
    SortingPopoverComponent,
    SimpleSortHeaderComponent,
    ColumnSelectComponent,
  ],
})
export class TableModule {
}
